import { Navigate, useOutlet } from "react-router-dom";

function getUserFromStorage() {
  try {
    const raw = localStorage.getItem("user_data");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export const AuthLayout = () => {
  const user = getUserFromStorage();
  const outlet = useOutlet();

  if (user) {
    return <Navigate to="/" replace/>;
  }

  return <div>{outlet}</div>;
};
